import React from 'react';
import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';

export default function PublicStaticLayout({ children, title }) {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-800 flex flex-col">
      <PublicHeader />
      <main id="main-content" className="flex-1 pt-20 pb-12 px-4 sm:px-6" tabIndex={-1}>
        <article className="max-w-3xl mx-auto">
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-8">{title}</h1>
          <div className="mt-2 space-y-4 text-slate-600 leading-relaxed [&_h2]:text-lg [&_h2]:font-semibold [&_h2]:text-slate-900 [&_h2]:pt-8 [&_h2]:mt-2 [&_h2]:border-t [&_h2]:border-slate-200 [&_h2]:first:border-0 [&_h2]:first:pt-0 [&_h2]:first:mt-0 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1 [&_a]:text-primary-600 [&_a]:underline-offset-2 hover:[&_a]:text-primary-700 [&_a]:focus-visible:outline [&_a]:focus-visible:outline-2 [&_a]:focus-visible:outline-offset-2 [&_a]:focus-visible:outline-primary-500">
            {children}
          </div>
        </article>
      </main>
      <PublicFooter />
    </div>
  );
}
